import React, { useEffect } from 'react';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Services from '../components/sections/Services';
import FAQ from '../components/sections/FAQ';
import Blog from '../components/sections/Blog';
import Contact from '../components/sections/Contact';
import { Award, Cpu, TrendingDown, UserCheck } from 'lucide-react';
import { setSEO } from '../utils/seo';

function Diferenciais() {
  return (
    <section className="bg-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-10">Por que escolher a Tavares Consulting?</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          <div className="flex flex-col items-center text-center">
            <Award className="w-10 h-10 text-blue-600 mb-3" />
            <h3 className="font-semibold text-lg mb-1">Experiência Comprovada</h3>
            <p className="text-gray-600 text-sm">Mais de 20 anos otimizando operações logísticas no Brasil.</p>
          </div>
          <div className="flex flex-col items-center text-center">
            <Cpu className="w-10 h-10 text-blue-600 mb-3" />
            <h3 className="font-semibold text-lg mb-1">Inovação e Tecnologia</h3>
            <p className="text-gray-600 text-sm">IA e machine learning aplicados para máxima eficiência.</p>
          </div>
          <div className="flex flex-col items-center text-center">
            <TrendingDown className="w-10 h-10 text-blue-600 mb-3" />
            <h3 className="font-semibold text-lg mb-1">Resultados Reais</h3>
            <p className="text-gray-600 text-sm">Redução média de custos de até 20% em nossos projetos.</p>
          </div>
          <div className="flex flex-col items-center text-center">
            <UserCheck className="w-10 h-10 text-blue-600 mb-3" />
            <h3 className="font-semibold text-lg mb-1">Atendimento Personalizado</h3>
            <p className="text-gray-600 text-sm">Consultoria próxima, focada nas necessidades da sua empresa.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  useEffect(() => {
    setSEO({
      title: 'Tavares Consulting | Consultoria de Logística e Supply Chain — São Paulo',
      description:
        'Consultoria especializada em logística e supply chain no Brasil. Daniel Tavares — mais de 20 anos de experiência em redução de frete, dimensionamento de CD, gestão de transportadoras e TMS. São Paulo, SP.',
    });
  }, []);

  return (
    <main>
      <Hero />
      <Diferenciais />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Nossos Serviços</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Oferecemos soluções completas em logística e supply chain para otimizar suas operações
            e impulsionar seus resultados.
          </p>
        </div>
      </div>
      <Services showTitle={false} />
      <About />
      <FAQ />
      <Blog />
      <Contact />
    </main>
  );
} 